import axios from "axios"
import { rodac_api, rodac_password, rodac_username } from "../../../env"
import { formatNumber } from "../../../Utils"

const DEBUG_PAYMENT_CONFIGURATIONS = false;

function getSubchannels(state, setState) {
   // setState(prevState => ({
   // ...prevState,
   // loader: true,
   // }))

   //   axios.get(
   //      `${rodac_api}/Autos/ConsultaSubcanales`,
   //      {
   //         params: {
   //         //    "Data.usuario": rodac_username,
   //         //    "Data.contraseña": rodac_password,
   //         }
   //      }
   //   ).then(res => {
   //      if(!res.data.Data.HasError) {
   //         setState(prevState => ({
   //            ...prevState,
   //            rodac: {
   //               ...prevState.rodac,
   //               fetch_subchannels: false,
   //               subchannels: res.data.Data.map(item => ({ id: item.IDSubCanal, subchannel: item.SubCanal })),
   //               subchannel_id: res.data.Data.find(item => item.SubCanal === "Seguros para el Crédito").IDSubCanal
   //            }
   //         }))
   //      }
   //   }).catch(error => {
   //      console.log(error)
   //   })
   setState(prevState => ({
      ...prevState,
      rodac: {
         ...prevState.rodac,
         fetch_subchannels: false,
         subchannels: [{ id: 20, subchannel: "Seguros para el Crédito" }],
         subchannel_id: 20
      }
   }))
}

function getCarTypes(state, setState) {
   // setState(prevState => ({
   // ...prevState,
   // loader: true,
   // }))

   //   axios.get(
   //      `${rodac_api}/Autos/ConsultaTiposDeVehiculos`,
   //      {
   //         params: {
   //         //    "Data.usuario": rodac_username,
   //         //    "Data.contraseña": rodac_password,
   //            "Data.idSubcanal": state.rodac.subchannel_id
   //         }
   //      }
   //   ).then(res => {
   //      if(!res.data.Data.HasError) {
   //         setState(prevState => ({
   //            ...prevState,
   //            rodac: {
   //               ...prevState.rodac,
   //               fetch_car_types: false,
   //               car_types: res.data.Data.Data.map(item => ({ id: item.Id, type: item.Valor })),
   //            }
   //         }))
   //      }
   //   }).catch(error => {
   //      console.log(error)
   //   })

   setState(prevState => ({
      ...prevState,
      rodac: {
         ...prevState.rodac,
         fetch_car_types: false,
         car_types: [
            {
               "id": 1,
               "type": "AUTO"
            },
            {
               "id": 2,
               "type": "PICKUP"
            }
         ],
      }
   }))
}

function getCarStatuses(state, setState) {
   // setState(prevState => ({
   // ...prevState,
   // loader: true,
   // }))

   //   axios.get(
   //      `${rodac_api}/Autos/ConsultaEstatusVehiculos`,
   //      {
   //         params: {
   //         //    "Data.usuario": rodac_username,
   //         //    "Data.contraseña": rodac_password,
   //            "Data.idSubcanal": state.rodac.subchannel_id
   //         }
   //      }
   //   ).then(res => {
   //      if(!res.data.Data.HasError) {
   //         setState(prevState => ({
   //            ...prevState,
   //            rodac: {
   //               ...prevState.rodac,
   //               fetch_car_statuses: false,
   //               car_statuses: res.data.Data.Data.map(item => ({ id: item.Id, status: item.Valor })),
   //            }
   //         }))
   //      }
   //   }).catch(error => {
   //      console.log(error)
   //   })
   setState(prevState => ({
      ...prevState,
      rodac: {
         ...prevState.rodac,
         fetch_car_statuses: false,
         car_statuses: [
            {
               "id": 1,
               "status": "NUEVO"
            },
            {
               "id": 2,
               "status": "SEMINUEVO"
            }
         ],
      }
   }))
}

function getUseTypes(state, setState) {
   // setState(prevState => ({
   // ...prevState,
   // loader: true,
   // }))

   //   axios.get(
   //      `${rodac_api}/Autos/ConsultaTiposUsos`,
   //      {
   //         params: {
   //         //    "Data.usuario": rodac_username,
   //         //    "Data.contraseña": rodac_password,
   //            "Data.idSubcanal": state.rodac.subchannel_id
   //         }
   //      }
   //   ).then(res => {
   //      if(!res.data.Data.HasError) {
   //         setState(prevState => ({
   //            ...prevState,
   //            rodac: {
   //               ...prevState.rodac,
   //               fetch_use_types: false,
   //               use_types: res.data.Data.Data.map(item => ({ id: item.Id, type: item.Valor })),
   //               use_type_id: res.data.Data.Data.find(item => item.Valor === "PARTICULAR").Id,
   //            }
   //         }))
   //      }
   //   }).catch(error => {
   //      console.log(error)
   //   })
   setState(prevState => ({
      ...prevState,
      rodac: {
         ...prevState.rodac,
         fetch_use_types: false,
         use_types: [
            {
               "id": 1,
               "type": "PARTICULAR"
            }
         ],
         use_type_id: 1,
      }
   }))
}

function getDeductibles(state, setState) {
   // setState(prevState => ({
   // ...prevState,
   // loader: true,
   // }))

   //   axios.get(
   //      `${rodac_api}/Autos/ConsultaDeducibles`,
   //      {
   //         params: {
   //         //    "Data.usuario": rodac_username,
   //         //    "Data.contraseña": rodac_password,
   //            "Data.idSubcanal": state.rodac.subchannel_id
   //         }
   //      }
   //   ).then(res => {
   //      if(!res.data.Data.HasError) {
   //         setState(prevState => ({
   //            ...prevState,
   //            rodac: {
   //               ...prevState.rodac,
   //               fetch_deductibles: false,
   //               deductibles: res.data.Data.Data.map(item => ({ id: item.Id, deductible: item.Valor })),
   //               deductible_id: res.data.Data.Data.find(item => item.Valor === "DM 5.00% | RT 10.00%").Id,
   //            }
   //         }))
   //      }
   //   }).catch(error => {
   //      console.log(error)
   //   })
   setState(prevState => ({
      ...prevState,
      rodac: {
         ...prevState.rodac,
         fetch_deductibles: false,
         deductibles: [
            {
               "id": 1,
               "deductible": "DM 5.00% | RT 10.00%"
            },
            {
               "id": 3,
               "deductible": "DM 3.00% | RT 5.00%"
            }
         ],
         deductible_id: 1,
      }
   }))
}

function getPolicyTypes(state, setState) {
   // setState(prevState => ({
   // ...prevState,
   // loader: true,
   // }))

   //   axios.get(
   //      `${rodac_api}/Autos/ConsultaTiposPoliza`,
   //      {
   //         params: {
   //         //    "Data.usuario": rodac_username,
   //         //    "Data.contraseña": rodac_password,
   //            "Data.idSubcanal": state.rodac.subchannel_id
   //         }
   //      }
   //   ).then(res => {
   //      if(!res.data.Data.HasError) {
   //         setState(prevState => ({
   //            ...prevState,
   //            rodac: {
   //               ...prevState.rodac,
   //               fetch_policy_types: false,
   //               policy_types: res.data.Data.Data.map(item => ({ id: item.Id, type: item.Valor })),
   //               policy_type_id: res.data.Data.Data.find(item => item.Valor === "MULTIANUAL").Id
   //            }
   //         }))
   //      }
   //   }).catch(error => {
   //      console.log(error)
   //   })
   setState(prevState => ({
      ...prevState,
      rodac: {
         ...prevState.rodac,
         fetch_policy_types: false,
         policy_types: [
            {
               "id": 1,
               "type": "ANUAL"
            },
            {
               "id": 2,
               "type": "MULTIANUAL"
            }
         ],
         policy_type_id: 2
      }
   }))
}

function getPackages(state, setState) {
   // setState(prevState => ({
   // ...prevState,
   // loader: true,
   // }))

   //   axios.get(
   //      `${rodac_api}/Autos/ConsultaPaquetes`,
   //      {
   //         params: {
   //         //    "Data.usuario": rodac_username,
   //         //    "Data.contraseña": rodac_password,
   //            "Data.idSubcanal": state.rodac.subchannel_id
   //         }
   //      }
   //   ).then(res => {
   //      if(!res.data.Data.HasError) {
   //         setState(prevState => ({
   //            ...prevState,
   //            rodac: {
   //               ...prevState.rodac,
   //               fetch_packages: false,
   //               packages: res.data.Data.Data.map(item => ({ id: item.Id, type: item.Valor })),
   //               package_id: res.data.Data.Data.find(item => item.Valor === "AMPLIA").Id,
   //            }
   //         }))
   //      }
   //   }).catch(error => {
   //      console.log(error)
   //   })
   setState(prevState => ({
      ...prevState,
      rodac: {
         ...prevState.rodac,
         fetch_packages: false,
         packages: [
            {
               "id": 2,
               "type": "AMPLIA"
            }
         ],
         package_id: 2,
      }
   }))
}

function getUdis(state, setState) {
   setState(prevState => ({
      ...prevState,
      loader: true,
   }))

   axios.get(
      `${rodac_api}/Autos/ConsultaUdis`,
      {
         params: {
            //    "Data.usuario": rodac_username,
            //    "Data.contraseña": rodac_password,
            "Data.idSubcanal": state.rodac.subchannel_id
         }
      }
   ).then(res => {
      // setTimeout(() => {
      if (!res.data.Data.HasError) {
         setState(prevState => ({
            ...prevState,
            loader: false,
            rodac: {
               ...prevState.rodac,
               fetch_udis: false,
               udis: res.data.Data.Data.map(item => ({ id: item.Id, udi: item.Valor })),
            },
         }))
      } else {
         setTimeout(() => {
            setState(prevState => ({
               ...prevState,
               loader: false,
               rodac: {
                  ...prevState.rodac,
                  fetch_udis: false,
               },
            }))
         }, 200)
      }
      // }, 1500)
   }).catch(error => {
      console.log(error)
   })
}

function getCompensations(state, setState) {
   //   axios.get(
   //      `${rodac_api}/Autos/ConsultaIdsIndenmizaciones`,
   //      {
   //         params: {
   //         //    "Data.usuario": rodac_username,
   //         //    "Data.contraseña": rodac_password,
   //            "Data.idSubcanal": state.rodac.subchannel_id,
   //            "Data.iDEstatusVehiculo": state.rodac.car_status_id,
   //         }
   //      }
   //   ).then(res => {
   //      if(!res.data.Data.HasError) {
   //         setState(prevState => ({
   //            ...prevState,
   //            rodac: {
   // ...prevState.rodac,
   // fetch_compensations: false,
   // compensations: res.data.Data.Data.map(item => ({ id: item.Id, type: item.Valor })),
   // compensation_id: res.data.Data.Data[0].Id,
   //            }
   //         }))
   //      }
   //   }).catch(error => {
   //      console.log(error)
   //   })

   setState(prevState => ({
      ...prevState,
      rodac: {
         ...prevState.rodac,
         fetch_compensations: false,
         compensations: [
            { id: 1, type: "Valor Factura" },
            { id: 4, type: "Valor Comercial" }
         ],
         compensation_id: prevState.rodac.car_status_id == 1 ? 1 : 4,
      }
   }))
}

function getModels(state, setState) {
   setState(prevState => ({
      ...prevState,
      loader: true,
   }))

   axios.post(
      `${rodac_api}/Autos/ConsultaModelos`,
      {
         // usuario: rodac_username,
         // Contraseña: rodac_password,
         IdSubcanal: /*state.rodac.subchannel_id*/ 20,
         IDEstatusVehiculo: state.rodac.car_status_id,
      },
      {
         headers: {
            "Content-Type": "application/x-www-form-urlencoded",
         }
      }
   ).then(res => {
      if (!res.data.Data.HasError) {
         setState(prevState => ({
            ...prevState,
            loader: false,
            rodac: {
               ...prevState.rodac,
               models: res.data.Data.Data
                  // .filter(item => item.Id !== 0)
                  .map(item => ({ id: item.Id, model: item.Valor })),
            }
         }))
      } else {
         setState(prevState => ({
            ...prevState,
            loader: false,
         }))
      }
   }).catch(error => {
      console.log(error)
   })
}

function getBrands(state, setState) {
   setState(prevState => ({
      ...prevState,
      loader: true,
   }))

   axios.post(
      `${rodac_api}/Autos/ConsultaMarcas`,
      {
         // usuario: rodac_username,
         // Contraseña: rodac_password,
         IDTipoVehiculo: state.rodac.car_type_id,
         modelo: state.rodac.model_id,
      },
      {
         headers: {
            "Content-Type": "application/x-www-form-urlencoded",
         }
      }
   ).then(res => {
      if (!res.data.Data.HasError) {
         setState(prevState => ({
            ...prevState,
            loader: false,
            rodac: {
               ...prevState.rodac,
               brands: res.data.Data.Data
                  // .filter(item => item.Id !== 0)
                  .map(item => ({ id: item.Id, brand: item.Valor, brand_id: item.IdMarca })),
            }
         }))
      } else {
         setState(prevState => ({
            ...prevState,
            loader: false,
         }))
      }
   }).catch(error => {
      console.log(error)
   })
}

function getTypes(state, setState) {
   setState(prevState => ({
      ...prevState,
      loader: true,
   }))

   axios.post(
      `${rodac_api}/Autos/ConsultaTipos`,
      {
         // usuario: rodac_username,
         // Contraseña: rodac_password,
         IDTipoVehiculo: state.rodac.car_type_id,
         modelo: state.rodac.model_id,
         submarca: state.rodac.brand,
      },
      {
         headers: {
            "Content-Type": "application/x-www-form-urlencoded",
         }
      }
   ).then(res => {
      if (!res.data.Data.HasError) {
         setState(prevState => ({
            ...prevState,
            loader: false,
            rodac: {
               ...prevState.rodac,
               types: res.data.Data.Data
                  // .filter(item => item.Id !== 0)
                  .map(item => ({ id: item.Id, type: item.Valor })),
            }
         }))
      } else {
         setState(prevState => ({
            ...prevState,
            loader: false,
         }))
      }
   }).catch(error => {
      console.log(error)
   })
}

function getDescriptions(state, setState) {
   setState(prevState => ({
      ...prevState,
      loader: true,
   }))

   axios.post(
      `${rodac_api}/Autos/ConsultaDescripciones`,
      {
         // usuario: rodac_username,
         // Contraseña: rodac_password,
         IDTipoVehiculo: state.rodac.car_type_id,
         modelo: state.rodac.model_id,
         submarca: state.rodac.brand,
         tipo: state.rodac.type,
      },
      {
         headers: {
            "Content-Type": "application/x-www-form-urlencoded",
         }
      }
   ).then(res => {
      if (!res.data.Data.HasError) {
         setState(prevState => ({
            ...prevState,
            loader: false,
            rodac: {
               ...prevState.rodac,
               descriptions: res.data.Data.Data
                  // .filter(item => item.Id !== 0)
                  .map(item => ({ id: item.Id, description: item.Valor })),
            }
         }))
      } else {
         setState(prevState => ({
            ...prevState,
            loader: false,
         }))
      }
   }).catch(error => {
      console.log(error)
   })
}

function getPaymentConfiguration(state, setState) {
   // setState(prevState => ({
   // ...prevState,
   // loader: true,
   // }))

   // axios.post(
   // `${rodac_api}/Autos/ConsultaConfiguracionPago`,
   // {
   // // usuario: rodac_username,
   // // contraseña: rodac_password,
   // IDSubcanal: state.rodac.subchannel_id,
   // IDTipoPoliza: state.rodac.policy_type_id,
   // },
   // {
   // headers: {
   // "Content-Type": "application/x-www-form-urlencoded",
   // }
   // }
   // ).then(res => {
   // if(!res.data.Data.HasError) {
   // setState(prevState => ({
   // ...prevState,
   // rodac: {
   // ...prevState.rodac,
   // payment_configurations: res.data.Data.Data
   // .filter(item => +item.Valor.split(" ")[0] !== 72)
   // .map(item => ({ id: item.Id, configuration: item.Valor.split(" ")[0] })),
   // }
   // }))
   // }
   // }).catch(error => {
   // console.log(error)
   // })
   setState(prevState => ({
      ...prevState,
      rodac: {
         ...prevState.rodac,
         payment_configurations: [
            {
               "Id": 13,
               "Valor": "24 MESES | ANUAL"
            },
            {
               "Id": 14,
               "Valor": "36 MESES | ANUAL"
            },
            {
               "Id": 15,
               "Valor": "48 MESES | ANUAL"
            },
            {
               "Id": 16,
               "Valor": "60 MESES | ANUAL"
            }
         ]
            .filter(item => +item.Valor.split(" ")[0] !== 72)
            .map(item => ({ id: item.Id, configuration: item.Valor.split(" ")[0] })),
      }
   }))
}

const delay = (ms = 200) => new Promise((r) => setTimeout(r, ms));

async function debugPaymentConfigurations(state) {
   const logSafePayload = payload => {
      const safe = { ...payload };
      if ('Contraseña' in safe) safe.Contraseña = safe.Contraseña ? '***' : safe.Contraseña;
      if ('contraseña' in safe) safe.contraseña = safe.contraseña ? '***' : safe.contraseña;
      if ('contrasena' in safe) safe.contrasena = safe.contrasena ? '***' : safe.contrasena;
      if ('Data.contraseña' in safe) safe['Data.contraseña'] = safe['Data.contraseña'] ? '***' : safe['Data.contraseña'];
      return safe;
   };

   const policyTypes = state.rodac.policy_types?.length
      ? state.rodac.policy_types
      : [
         { id: 1, type: "ANUAL" },
         { id: 2, type: "MULTIANUAL" },
      ];

   policyTypes.forEach(policyType => {
      const payload = {
         usuario: rodac_username,
         Contraseña: rodac_password,
         contraseña: rodac_password,
         contrasena: rodac_password,
         IDSubcanal: state.rodac.subchannel_id,
         IDTipoPoliza: policyType.id,
      };

      /* console.log('[Rodac formas pago] request', {
         variant: 'post-json',
         policyType,
         payload: logSafePayload(payload),
      }); */

      axios.post(
         `${rodac_api}/Autos/ConsultaConfiguracionPago`,
         payload,
         {
            headers: {
               "Content-Type": "application/x-www-form-urlencoded",
            }
         }
      ).then(res => {
         /* console.log('[Rodac formas pago] response', {
            variant: 'post-json',
            policyType,
            status: res.status,
            data: res.data,
         }); */
      }).catch(error => {
         console.error('[Rodac formas pago] error', {
            variant: 'post-json',
            policyType,
            status: error.response?.status,
            data: error.response?.data,
            message: error.message,
            payload: logSafePayload(payload),
         });
      });

      const formPayload = new URLSearchParams();
      Object.entries(payload).forEach(([key, value]) => {
         if (value !== null && value !== undefined) {
            formPayload.append(key, value);
         }
      });

      /*  console.log('[Rodac formas pago] request', {
          variant: 'post-form',
          policyType,
          payload: logSafePayload(payload),
       }); */

      axios.post(
         `${rodac_api}/Autos/ConsultaConfiguracionPago`,
         formPayload,
         {
            headers: {
               "Content-Type": "application/x-www-form-urlencoded",
            }
         }
      ).then(res => {
         /*  console.log('[Rodac formas pago] response', {
             variant: 'post-form',
             policyType,
             status: res.status,
             data: res.data,
          }); */
      }).catch(error => {
         /*    console.error('[Rodac formas pago] error', {
               variant: 'post-form',
               policyType,
               status: error.response?.status,
               data: error.response?.data,
               message: error.message,
               payload: logSafePayload(payload),
            }); */
      });

      const params = {
         "Data.usuario": rodac_username,
         "Data.contraseña": rodac_password,
         "Data.idSubcanal": state.rodac.subchannel_id,
         "Data.idTipoPoliza": policyType.id,
      };

      /* console.log('[Rodac formas pago] request', {
         variant: 'get-data-params',
         policyType,
         payload: logSafePayload(params),
      }); */

      axios.get(
         `${rodac_api}/Autos/ConsultaConfiguracionPago`,
         { params }
      ).then(res => {
         /* console.log('[Rodac formas pago] response', {
            variant: 'get-data-params',
            policyType,
            status: res.status,
            data: res.data,
         }); */
      }).catch(error => {
         /*  console.error('[Rodac formas pago] error', {
             variant: 'get-data-params',
             policyType,
             status: error.response?.status,
             data: error.response?.data,
             message: error.message,
             payload: logSafePayload(params),
          }); */
      });
   });
}

async function fetchInsurancesSingle(idPagoVigencia, del = 200, state) {
   await delay(del);
   const paymentConfig = state.rodac.payment_configurations.find(item => +item.id === +idPagoVigencia);
   const payload = {
      ClaveVehiculo: state.rodac.description_id,
      IDTipoVehiculo: state.rodac.car_type_id,
      IDEstatusVehiculo: state.rodac.car_status_id,
      IDIndenmizacion: state.rodac.compensation_id,
      SumaAsegurada: state.rodac.amount,
      CodigoPostal: state.rodac.zip,
      IDTipoUso: state.rodac.use_type_id,
      IDDeducibles: state.rodac.deductible_id,
      IDPagoVigencia: idPagoVigencia,
      IDUDI: state.rodac.udi_id,
      IDPaquete: state.rodac.package_id,
      ColoniaPersona: state.rodac.colonia?.colonia || state.rodac.colonia,
      MunicipioPersona: state.rodac.municipio,
      CiudadPersona: state.rodac.ciudad,
      EstadoPersona: state.rodac.estado,
      // usuario: rodac_username,
      // Contraseña: rodac_password,
      IDSubcananal: state.rodac.subchannel_id,
   };

   /*  console.log('[Rodac seguros] request', {
       plazo: paymentConfig?.configuration,
       idPagoVigencia,
       payload,
    }); */

   return axios.post(
      `${rodac_api}/Autos/Cotizaciones`,
      payload,
      {
         headers: {
            "Content-Type": "application/x-www-form-urlencoded",
         }
      }
   ).then(res => {
      /*  console.log('[Rodac seguros] response', {
          plazo: paymentConfig?.configuration,
          idPagoVigencia,
          status: res.status,
          data: res.data,
       }); */
      return res;
   }).catch(error => {
      /*  console.error('[Rodac seguros] error', {
          plazo: paymentConfig?.configuration,
          idPagoVigencia,
          status: error.response?.status,
          data: error.response?.data,
          message: error.message,
          payload,
       }); */
      throw error;
   })
}
const getThreeInsurances = async function (ids, state) {
   let results = [];

   try {
      /*  console.log('[Rodac seguros] batch start', {
          ids,
          plazos: state.plazos,
          paymentConfigurations: state.rodac.payment_configurations,
       }); */
      const requestsList = ids.map((id, i) => fetchInsurancesSingle(id, i * 400, state));
      const responses = await Promise.all(requestsList);

      return responses.map(res => res.data);

   } catch (error) {
      console.error('[Rodac seguros] batch error', error);
      return results;
   }

};
function getInsurances(state, setState, plazos) {
   setState(prevState => ({
      ...prevState,
      loader: true,
   }))

   let plazosID = [...state.plazos.idarray];
   let currentIdIndex = state.plazos.currentIndex;

   if (DEBUG_PAYMENT_CONFIGURATIONS) {
      debugPaymentConfigurations(state);
   }

   /*  console.log('[Rodac seguros] getInsurances', {
       plazosID,
       currentIdIndex,
       plazos: state.plazos,
       selectedPaymentConfigurationId: state.rodac.payment_configuration_id,
    }); */

   getThreeInsurances(plazosID, state)
      .then(res => {
         if (res[currentIdIndex]) {
            let plazosInsurances = res.map(insuranceArr => {
               const data = insuranceArr?.Data?.Data;
               if (!Array.isArray(data)) {
                  console.warn('[Rodac seguros] respuesta sin lista de seguros', insuranceArr);
                  return [];
               }

               return data.filter(item => !item.HasError)
                  .map(item => ({
                     id: item.IDCotizacion,
                     insurance: `${item.LogoAseguradora.replace("Logo", "").split(".")[0].toUpperCase()} - ${formatNumber((+item.PrimaTotal).toFixed(2))}`,
                     serial: item.Folio,
                     amount: +item.PrimaTotal,
                     logo: item.LogoAseguradora
                  }))
            })

            let insurances = [...(plazosInsurances[state.plazos.currentIndex] || [])];

            // por alguna razón no funciona sin el timeout
            setTimeout(() => {
               setState(prevState => ({
                  ...prevState,
                  loader: false,
                  rodac: {
                     ...prevState.rodac,
                     fetch_insurances: false,
                     fetched_insurances: true,
                     plazosInsurances: [...plazosInsurances],
                     insurances: insurances,
                  }
               }))
            }, 300)

         } else {
            setState(prevState => ({
               ...prevState,
               loader: false,
               rodac: {
                  ...prevState.rodac,
                  fetch_insurances: false,
                  fetched_insurances: false,
               }
            }))
         }
      })
      .catch(e => console.log(e))
      .finally(() => {
         if (state.rodac.fetch_insurances)
            setState(prevState => ({
               ...prevState,
               rodac: {
                  ...prevState.rodac,
                  fetch_insurances: false,
                  loader: false,
               }
            }))
      })

   // axios.post(
   // `${rodac_api}/Autos/Cotizaciones`,
   // {
   // ClaveVehiculo: state.rodac.description_id,
   // IDTipoVehiculo: state.rodac.car_type_id,
   // IDEstatusVehiculo: state.rodac.car_status_id,
   // IDIndenmizacion: state.rodac.compensation_id,
   // SumaAsegurada: state.rodac.amount,
   // CodigoPostal: state.rodac.zip,
   // IDTipoUso: state.rodac.use_type_id,
   // IDDeducibles: state.rodac.deductible_id,
   // IDPagoVigencia: state.rodac.payment_configuration_id,
   // //IDPagoVigencia: plazos.current.id,
   // IDUDI: state.rodac.udi_id,
   // IDPaquete: state.rodac.package_id,
   // ColoniaPersona: state.rodac.colonia,
   // MunicipioPersona: state.rodac.municipio,
   // CiudadPersona: state.rodac.ciudad,
   // EstadoPersona: state.rodac.estado,
   // usuario: rodac_username,
   // Contraseña: rodac_password,
   // IDSubcananal: state.rodac.subchannel_id,
   // },
   // {
   // headers: {
   // "Content-Type": "application/x-www-form-urlencoded",
   // }
   // }
   // ).then(res => {
   // if(!res.data.Data.HasError) {
   // setState({
   // ...state,
   // loader: false,
   // rodac: {
   // ...state.rodac,
   // fetch_insurances: false,
   // fetched_insurances: true,
   // insurances: res.data.Data.Data
   // .filter(item => !item.HasError)
   // .map(item => ({ id: item.IDCotizacion, insurance: `${item.LogoAseguradora.replace("Logo", "").split(".")[0].toUpperCase()} - ${formatNumber((+item.PrimaTotal).toFixed(2))}`, serial: item.Folio, amount: +item.PrimaTotal, logo: item.LogoAseguradora })),
   // }
   // })
   // } else {
   // setState({
   // ...state,
   // loader: false,
   // fetch_insurances: false,
   // fetched_insurances: false,
   // })
   // }
   // }).catch(err => {
   // console.log(err)
   // })

   // axios.post(
   // `${rodac_api}/Autos/Cotizaciones`,
   // {
   // ClaveVehiculo: state.rodac.description_id,
   // IDTipoVehiculo: state.rodac.car_type_id,
   // IDEstatusVehiculo: state.rodac.car_status_id,
   // IDIndenmizacion: state.rodac.compensation_id,
   // SumaAsegurada: state.rodac.amount,
   // CodigoPostal: state.rodac.zip,
   // IDTipoUso: state.rodac.use_type_id,
   // IDDeducibles: state.rodac.deductible_id,
   // IDPagoVigencia: plazos.prev.id,
   // IDUDI: state.rodac.udi_id,
   // IDPaquete: state.rodac.package_id,
   // ColoniaPersona: state.rodac.colonia,
   // MunicipioPersona: state.rodac.municipio,
   // CiudadPersona: state.rodac.ciudad,
   // EstadoPersona: state.rodac.estado,
   // usuario: rodac_username,
   // Contraseña: rodac_password,
   // IDSubcananal: state.rodac.subchannel_id,
   // },
   // {
   // headers: {
   // "Content-Type": "application/x-www-form-urlencoded",
   // }
   // }
   // ).then(res => {
   // if(!res.data.Data.HasError) {
   // setState({
   // ...state,
   // loader: false,
   // rodac: {
   // ...state.rodac,
   // fetch_insurances: false,
   // fetched_insurances: true,
   // insurances: res.data.Data.Data
   // .filter(item => !item.HasError)
   // .map(item => ({ id: item.IDCotizacion, insurance: `${item.LogoAseguradora.replace("Logo", "").split(".")[0].toUpperCase()} - ${formatNumber((+item.PrimaTotal).toFixed(2))}`, serial: item.Folio, amount: +item.PrimaTotal, logo: item.LogoAseguradora })),
   // }
   // })
   // } else {
   // setState({
   // ...state,
   // loader: false,
   // fetch_insurances: false,
   // fetched_insurances: false,
   // })
   // }
   // }).catch(err => {
   // console.log(err)
   // })

   // axios.post(
   // `${rodac_api}/Autos/Cotizaciones`,
   // {
   // ClaveVehiculo: state.rodac.description_id,
   // IDTipoVehiculo: state.rodac.car_type_id,
   // IDEstatusVehiculo: state.rodac.car_status_id,
   // IDIndenmizacion: state.rodac.compensation_id,
   // SumaAsegurada: state.rodac.amount,
   // CodigoPostal: state.rodac.zip,
   // IDTipoUso: state.rodac.use_type_id,
   // IDDeducibles: state.rodac.deductible_id,
   // IDPagoVigencia: plazos.next.id,
   // IDUDI: state.rodac.udi_id,
   // IDPaquete: state.rodac.package_id,
   // ColoniaPersona: state.rodac.colonia,
   // MunicipioPersona: state.rodac.municipio,
   // CiudadPersona: state.rodac.ciudad,
   // EstadoPersona: state.rodac.estado,
   // usuario: rodac_username,
   // Contraseña: rodac_password,
   // IDSubcananal: state.rodac.subchannel_id,
   // },
   // {
   // headers: {
   // "Content-Type": "application/x-www-form-urlencoded",
   // }
   // }
   // ).then(res => {
   // if(!res.data.Data.HasError) {
   // setState({
   // ...state,
   // loader: false,
   // rodac: {
   // ...state.rodac,
   // fetch_insurances: false,
   // fetched_insurances: true,
   // insurances: res.data.Data.Data
   // .filter(item => !item.HasError)
   // .map(item => ({ id: item.IDCotizacion, insurance: `${item.LogoAseguradora.replace("Logo", "").split(".")[0].toUpperCase()} - ${formatNumber((+item.PrimaTotal).toFixed(2))}`, serial: item.Folio, amount: +item.PrimaTotal, logo: item.LogoAseguradora })),
   // }
   // })
   // } else {
   // setState({
   // ...state,
   // loader: false,
   // fetch_insurances: false,
   // fetched_insurances: false,
   // })
   // }
   // }).catch(err => {
   // console.log(err)
   // })
}

function getDateInDays(days) {
   const dateCopy = new Date();
   dateCopy.setDate(dateCopy.getDate() + days);

   // Get the year, month, and day components
   const year = dateCopy.getFullYear();
   const month = String(dateCopy.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed, so we add 1
   const day = String(dateCopy.getDate()).padStart(2, '0');

   // Format the date as YYYY-MM-DD
   const formattedDate = `${year}-${month}-${day}`;

   return formattedDate;
}

export {
   getSubchannels,
   getCarTypes,
   getCarStatuses,
   getUseTypes,
   getDeductibles,
   getPolicyTypes,
   getPackages,
   getUdis,
   getCompensations,
   getModels,
   getBrands,
   getTypes,
   getDescriptions,
   getPaymentConfiguration,
   getInsurances,
   getDateInDays
}
